<template lang="html">
<section id="services" class="padded">
	<h1 v-if="about[currentLang].servicesTitle" class="discret dark">{{ about[currentLang].servicesTitle }}</h1>
	<h1 v-else class="discret dark">{{ $t("services") }}</h1>
	<div class="content flex" v-if="about[currentLang].services">
		<section class="inner-content" v-for="(services, index) in about[currentLang].services" :key="'cat'+index">
			<h1>{{services.categorie}}</h1>
			<ul v-if="services.services.length">
				<li v-for="(service, index2) in services.services" :key="'service'+index2">{{service.name}}</li>
			</ul>
		</section>
	</div>
</section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'

export default {
	mixins: [scrollBehavior],
	props: ['about', 'site', 'currentLang'],
}
</script>

<style lang="scss">
	#app  #services{
		margin-top: 3.45rem;
		margin-bottom: 3rem;
		@media screen and (min-width:768px){
			margin-bottom: 7.5rem;
		}
		.content{
			padding-top:2.1rem;
			justify-content:space-between;
			section.inner-content{
				@media screen and (max-width:768px){
					margin-bottom: 1.5rem;
				}
				flex:inherit;
				width:auto;
				padding-top:0;
				min-width: 22%;
				h1{
					font-size: 1.3rem;
					font-family: 'surtSemiBold_extended', Helvetica, Arial, sans-serif;
					line-height: 1.933rem;
					margin-bottom:1rem;
					letter-spacing:0.86px;
					@media screen and (min-width:768px){
						font-size: 1.6rem;
					}
				}
				ul{
					li{
						font-size:1rem;
						line-height: 2rem;
						letter-spacing:0.11px;
						color:rgba(32, 34, 38,.9);
						position:relative;
						padding-left:2rem;
						@media screen and (min-width:768px){
							font-size:1.2rem;
							line-height: 2.467rem;
						}
						&:before{
							content:"";
							width:8px;
							height:8px;
							border-radius:100%;
							background-color:#FF2E60;
							position: absolute;
							left: 0;
							top: 50%;
							@include transform(translate(0, -50%));
						}
					}
				}
			}
		}
	}
</style>
